import { Box, BoxProps } from '@chakra-ui/react';
import styled from '@emotion/styled';
import React, { ReactElement } from 'react';

interface Props extends BoxProps {
  icon: ReactElement;
  color?: string;
}

const SVGStyleProvider = styled(Box)`
  & svg {
    margin: 0 auto;
    & > path {
      fill: ${({ color }) => color};
    }
  }
`;

const SVGWrapper = ({ icon, color = 'currentColor', ...rest }: Props) => (
  <SVGStyleProvider as="span" color={color} {...rest}>
    {React.cloneElement(icon, {
      height: icon.props.height || 16,
    })}
  </SVGStyleProvider>
);

export default SVGWrapper;
